import { useSessionContext } from '@/contexts/session/context';
import type { ChatMessage } from '@/contexts/chat/scripts/hooks/useChatMessages/types';
import { useGroupMessageReaders } from '@/contexts/chat/scripts/hooks/useChatGroup/hooks';
import { isMeMessage } from '@/contexts/chat/scripts/hooks/useChatMessages/utils';
import type { MentionBaseProps } from '../mention-base';
import MentionBase from '../mention-base';

export interface MentionMessageProps extends MentionBaseProps {
  msg: ChatMessage;
}

export default function MentionMessage(props: MentionMessageProps) {
  const { user, msg } = props;
  const {
    session: { user: self },
  } = useSessionContext();
  // TODO amo: Optimize
  const { readerIds } = useGroupMessageReaders({ message: msg });
  const isSender = useMemo(() => isMeMessage(msg), [msg]);

  const isSelf = useMemo(() => user.user_id === self?.userId, [user, self]);

  const dot = useMemo(
    () =>
      isSelf || user.user_id === '*' || !isSender
        ? undefined
        : readerIds.includes(user.user_id)
          ? 'solid'
          : 'hollow',
    [isSelf, isSender, readerIds, user.user_id]
  );

  return <MentionBase filled={isSelf} dot={dot} {...props}></MentionBase>;
}
